<template>
    <div class="d-flex flex-column" v-if="isSubscription">
        <div class="single-subscription">
            <b-row>
                <b-col class="d-flex">
                    <icon-pill @click.native="$emit('toggle-subscription-table')" icon="arrow-left" />
                    <div class="ml-4">
                        <div class="headline">{{ $t('cdb.subscriptions.tab_subscriptions') }}</div>
                        <div class="subtext">Order no.: {{ subscription.order_number }}</div>
                    </div>
                </b-col>
                <b-col class="d-flex justify-content-end">
                    <div class="d-flex flex-column">
                        <div>
                            {{ $t('fdb.filter.status') }} <status-pill :status="subscription.statusDisplay.statusType" :text="subscription.statusDisplay.statusLabel" class="ml-2"/>
                        </div>
                        <div class="subtext mt-2">{{ $t('fdb.subscriptions.start') }}: {{ subscription.started_at }} · {{ $t('fdb.subscriptions.end') }}: {{ subscription.ends_at }}</div>
                    </div>
                    <b-button v-if="showCancelButton" variant="danger" class="ml-5" @click="isSubscriptionCancelModalVisible = true">{{ $t('cdb.subscription.cancelSubscription.submit') }}</b-button>
                </b-col>
            </b-row>
        </div>
        <div class="single-subscription">
            <b-row>
                <b-col cols="12" md="4">
                    <subscription-description-box :title="$t('fdb.tab.subscription.vehicle')">
                        <template v-slot:content>
                            <b-img fluid :src="subscription.vehicle.title_image.url" />
                            <div class="mt-2">{{ subscription.vehicle.model.title }}</div>
                            <div class="model-type">{{ subscription.vehicle.model.brand.title }}</div>
                        </template>
                    </subscription-description-box>
                </b-col>
                <b-col cols="12" md="4">
                    <subscription-description-box :title="$t('fdb.tab.subscription.driver')">
                        <template v-slot:content>
                            <div class="d-flex my-2">
                                <div class="text-bold">{{ $t('global.fields.name.label') }}</div>
                                <div class="ml-auto text-right">{{ subscription.userFullName }}</div>
                            </div>
                            <div class="d-flex my-2">
                                <div class="text-bold">{{ $t('fdb.filter.order_no') }}</div>
                                <div class="ml-auto text-right">{{ subscription.order_number }}</div>
                            </div>
                            <div class="d-flex my-2">
                                <div class="text-bold">{{ $t('fdb.subscriptions.net_price') }}</div>
                                <div class="ml-auto text-right">{{ subscription.price_plan.price_without_tax }} {{ subscription.price_plan.currency.toUpperCase() }} / {{ $t('cat.product_tile.month') }}</div>
                            </div>
                            <div class="d-flex my-2">
                                <div class="text-bold">{{ $t('global.fields.duration.label') }}</div>
                                <div class="ml-auto text-right">{{ `${subscription.price_plan.duration} ${$t('fdb.subscriptions.months')}` }}</div>
                            </div>
                            <div class="d-flex my-2">
                                <div class="text-bold">{{ $t('global.fields.duration.type') }}</div>
                                <div class="ml-auto text-right">
                                    <span v-if="subscription.fixed_duration">
                                        {{ $t('fdb.subscriptions.fixed_term') }}
                                    </span>
                                    <span v-else>
                                        {{ $t('fdb.subscriptions.variable_term') }}
                                    </span>
                                </div>
                            </div>
                            </template>
                    </subscription-description-box>
                </b-col>
                <b-col cols="12" md="4">
                    <subscription-description-box :title="$t('fdb.tab.subscription.details')">
                        <template v-slot:content>
                            <div class="d-flex my-2">
                                <div class="text-bold">
                                    {{ $t('cdb.subscriptions.mileage') }}
                                </div>
                                <div class="ml-auto text-right">{{ `${subscription.price_plan.mileage} ${$t('fdb.subscriptions.km_month')}` }}</div>
                            </div>
                            <div class="d-flex my-2">
                                <div class="text-bold">{{ $t('cdb.subscriptions.additional_mileage') }}</div>
                                <div class="ml-auto text-right">{{ subscription.additional_mileage_costs.net_costs }} {{ subscription.additional_mileage_costs.currency.iso.toUpperCase() }} / {{ $t('pds.delivery_cost.unit_of_distance') }}</div>
                            </div>
                            <div class="d-flex my-2">
                                <div class="text-bold">{{ $t('co.subscription.overview.deductible') }}</div>
                                <div class="ml-auto text-right">{{ subscription.damage_participation }}</div>
                            </div>
                            <div class="d-flex my-2">
                                <div class="text-bold">{{ $t('cdb.subscriptions.delivery.delivery') }}</div>
                                <div class="ml-auto text-right"> {{ isDeliverable }} </div>
                            </div>
                            <div class="d-flex my-2">
                                <div class="text-bold">{{ $t('fdb.subscriptions.origin') }}</div>
                                <div class="ml-auto text-right"> {{ subscription.vehicle.address.name }}</div>
                            </div>
                        </template>
                        <template v-slot:button>
                            <div class="subscription-description-button" v-if="showChangeMileagePackageButton" @click="isSubscriptionChangeMileageModalVisible = true">
                                {{ $t('cdb.changeMileage.title') }}
                            </div>
                        </template>
                    </subscription-description-box>
                </b-col>
            </b-row>
        </div>
        <subscription-change-mileage-modal :subscription="subscription" :visible="isSubscriptionChangeMileageModalVisible" @hide="isSubscriptionChangeMileageModalVisible = false" @change-mileage="changeMileage"/>
        <subscription-cancel-modal :subscription="subscription" :visible="isSubscriptionCancelModalVisible" @hide="isSubscriptionCancelModalVisible = false" @cancel-subscription="cancelSubscription" />
    </div>
</template>

<script>
import { BButton, BCol, BRow, BImg } from "bootstrap-vue";
import StatusPill from "../atoms/StatusPill.vue";
import IconPill from "../atoms/IconPill.vue";
import SubscriptionDescriptionBox from "../atoms/SubscriptionDescriptionBox.vue";
import Modal from "../atoms/Modal.vue";
import SubscriptionCancelModal from "../molecules/SubscriptionCancelModal.vue";
import SubscriptionChangeMileageModal from "../molecules/SubscriptionChangeMileageModal.vue";
import StatusMixin from "../../../mixins/StatusMixin.vue";

export default {
    name: 'FdbTabSubscriptionsSingle',
    components: {
        SubscriptionChangeMileageModal,
        SubscriptionCancelModal, SubscriptionDescriptionBox, IconPill, BRow, BCol, StatusPill, BButton, Modal, BImg },
    mixins: [ StatusMixin ],
    data() {
        return {
            isVisible: true,
            isSubscriptionChangeMileageModalVisible: false,
            isSubscriptionCancelModalVisible: false
        }
    },
    props: {
        subscription: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        isSubscription() {
            return Object.keys(this.subscription).length
        },
        isDeliverable() {
            return this.subscription.vehicle.deliverable ? this.$t('pds.new_vehicle.yes') : this.$t('pds.new_vehicle.no')
        },
        showCancelButton() {
            return this.subscription.status === 'SUBSCRIPTION_ACTIVE';
        },
        showChangeMileagePackageButton() {
            return (this.subscription.status === 'SUBSCRIPTION_ACTIVE' || this.subscription.status === 'SUBSCRIPTION_CUSTOMER_CANCELLATION') && this.subscription.type != 'MVS'
        },
    },
    methods: {
        cancelSubscription(params) {
            const { returnType, delivery } = params
            this.$emit('cancel-subscription', { returnType, uuid: this.subscription.uuid, delivery })
            this.$nextTick( () => {
                this.isSubscriptionCancelModalVisible = false
            })
        },
        changeMileage(params) {
            const { mileage, price } = params
            this.$emit('change-mileage', { mileage, uuid: this.subscription.uuid, price})
            this.$nextTick( () => {
                this.isSubscriptionChangeMileageModalVisible = false
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.single-subscription {
    background: #F8F8F8;
    padding: 64px 96px;
    .headline {
        font-size: 20px;
        color: #000;
        font-weight: bold;
    }
    .subtext {
        font-size: 10px;
        color: #7e7e7e;
    }
    &:first-child {
        border-bottom: 2px solid #F0F0F0
    }
    .model-type {
        font-size: 12px;
    }
}
</style>
